import { ChangeDetectionStrategy, Component, inject, input, model, output } from '@angular/core';
import { environment } from '@libs/environment';
import { IContact } from '@libs/models/models';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DeviceService } from '@libs/services/device.service';
import { AsyncPipe } from '@angular/common';
import { PaymentButtonComponent } from '@libs/shared/components/header/components/payment-button/payment-button.component';

@Component({
  selector: 'app-header-dropdown',
  templateUrl: `./templates/${environment.name}/page.html`,
  styleUrls: [`./templates/${environment.name}/style.sass`],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, AsyncPipe, PaymentButtonComponent]
})
export class HeaderDropdownComponent {
  private deviceService = inject(DeviceService);
  public phones = input<IContact[]>([]);
  public isLoanExist = input<boolean>();
  public isLogoutVisible = input<boolean>();
  public isDropdown = model(false);
  public readonly logoutEvent = output<void>();
  public isDesktop$: Observable<boolean> = this.deviceService.isDesktop;

  public logout(): void {
    this.dropdownClicked();
    this.logoutEvent.emit();
  }

  public dropdownClicked(): void {
    this.isDropdown.set(!this.isDropdown());
  }
}
